module.exports = __webpack_public_path__ + "static/media/nucleo-icons.42643978.woff2";